import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: '40px',
            textAlign: 'center',
            color: '#555',
            background: '#fff8f8',
            border: '1px solid #ffcccc',
            borderRadius: '8px',
            margin: '20px',
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚠️</div>
          <h3 style={{ color: '#e53935', marginBottom: '8px' }}>Terjadi Kesalahan</h3>
          <p style={{ color: '#666', marginBottom: '4px' }}>
            Halaman ini tidak dapat ditampilkan.
          </p>
          <p style={{ color: '#888', fontSize: '13px', marginBottom: '20px' }}>
            <strong>Data yang sudah Anda input telah disimpan.</strong><br />
            Klik tombol di bawah untuk kembali — data Anda akan dipulihkan secara otomatis.
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.history.back();
              }}
              style={{
                padding: '10px 28px',
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              ← Kembali &amp; Pulihkan Data
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 28px',
                background: '#fff',
                color: '#666',
                border: '1px solid #ccc',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              Refresh Halaman
            </button>
          </div>
          <details style={{ marginTop: '20px', fontSize: '11px', color: '#bbb', textAlign: 'left' }}>
            <summary style={{ cursor: 'pointer' }}>Detail Error (untuk teknisi)</summary>
            <pre style={{ overflow: 'auto', marginTop: '8px', background: '#f5f5f5', padding: '8px', borderRadius: '4px' }}>
              {this.state.error && this.state.error.toString()}
            </pre>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
